import { gql } from "@apollo/client";

export const GET_INITIAL_CALL_INFO = gql`
  query GET_INITIAL_CALL_INFO($incidentId: ID!, $originatorId: ID!) {
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      blocked(employeeId: $originatorId)
      narrativesBlocked(employeeId: $originatorId)
      incidentFlags {
        id
        name
      }
      poldInstance {
        id
        address {
          id
          name
        }
        business {
          id
          personalAttribute {
            lastName
            firstName
          }
        }
        createdAt
        hasPold
        incident {
          id
        }
        updatedAt
      }
      incidentDetail {
        id
        alcohol
        occurredFrom
        occurredTo
        investigatingOfficer {
          id
          deptAttribute {
            id
            badge
            stateIdNumber
            ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        incidentOffenses {
          id
          locationType {
            id
            name
          }
          offenseViolationPrototype {
            id
            yoe
            offenseCategory {
              id
              name
            }
          }
          suspectVictimAffiliations {
            id
            sealed
            suspect {
              id
              personalAttribute {
                id
                dob
              }
            }
            victim {
              id
              personalAttribute {
                id
                dob
              }
            }
          }
        }
      }
      incidentArrests {
        id
        sealed
        arrestee {
          id
          personalAttribute {
            id
            lastName
            firstName
            dob
          }
        }
        arrestCharges {
          id
          sealed
          offenseViolationPrototype {
            id
            yoe
          }
        }
      }
      incidentProperties {
        id
        __typename
        colorType {
          id
        }
        description
        disposed
        ibrPropertyDescription {
          id
        }
        ibrSuspectedDrugType {
          id
        }
        incidentOffenses {
          id
          offenseViolationPrototype {
            id
            yoe
          }
          suspectVictimAffiliations {
            id
            suspect {
              id
              personalAttribute {
                id
                dob
              }
            }
          }
        }
        labAnalysisInstances {
          id
        }
        location {
          id
        }
        make
        nibrsRelated
        owner {
          id
        }
        ownerNotified
        propertyCode {
          id
        }
        quantity
        serialNumber
        tagNumber
        taggedAt
        taggedBy {
          id
        }
        tempEvidence
        tempEvidenceLocationType {
          id
        }
        unitMeasureType {
          id
        }
        value
        vehicle {
          id
        }
      }
      incidentTickets {
        id
        issuedTo {
          id
          personalAttribute {
            id
            organization
          }
        }
        ticketNumber
        vehicle {
          id
        }
        currentStatus
        penalty
        operator {
          id
          personalAttribute {
            id
            dob
            firstName
            lastName
            middleName
            gender {
              id
              name
            }
          }
        }
        uofInstance {
          id
          name
        }
        uofInstanceTypes {
          id
          name
        }
        uofInjuryDetails {
          id
          name
        }
        perceivedRace {
          id
          name
        }
        ticketStopType {
          id
          name
        }
        ticketSearchType {
          id
          name
        }
        ticketEvidenceType {
          id
          name
        }
        ticketOutcomeType {
          id
          name
        }
        passengerTicketEvidenceType {
          id
          name
        }
        passengerTicketOutcomeType {
          id
          name
        }
        passengerTicketSearchType {
          id
          name
        }
        uofInjuryDetails {
          id
          name
        }
        uofInstance {
          id
          name
        }
        uofInstanceTypes {
          id
          name
        }
        weightLimit {
          id
          name
        }
        violationOccurrence {
          id
          name
        }
        ticketViolationPrototype {
          id
          name
          fullName
          civilViolation
          municipalOrdinance
          speedingVio
          doNotSubmit
          title
          statute
          section
          code
          ticketCategory {
            id
            name
          }
          ticketEntry {
            name
          }
          waiver
        }
      }
      incidentReview {
        id
        reviewStatus {
          id
          name
        }
        statusDate
        approvalStatus {
          id
          name
        }
        investigatingOfficer {
          id
        }
        reviewDate
      }
      address {
        __typename
        id
        name
        validAddressAlerts {
          __typename
          alertType {
            __typename
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
        streetNumber
        streetName
        unit
        city
        state
        zip
        lat
        lng
      }
      area {
        id
        name
        oriId
        position
      }
      callCancelled
      callTime
      cargoTheft
      classification {
        id
        name
        oriId
        position
      }
      commonCallType {
        id
        name
        oriId
        position
      }
      domv
      drugTypes {
        id
        name
        oriId
        position
      }
      drugRelated
      employee {
        id
        personalAttribute {
          firstName
          id
          lastName
          middleName
          phone
        }
        deptAttribute {
          assignment
          badge
          carNumber
          id
          lastContactedAt
          notes
          stateIdNumber
          ori {
            id
            oriName
            abbreviation
          }
          radioNumber
          secondaryAddress
          skillsList
          status
        }
      }
      inactive
      id
      incidentNumber
      incidentOrigin {
        id
        name
        oriId
        position
      }
      callPriority {
        id
        name
        oriId
        position
      }
      incidentPriority {
        id
        name
        oriId
        position
      }
      linkedIncidents {
        id
        incidentNumber
      }
      mentalHealthRelated
      narratives
      nicEntries {
        id
        cancelled
        incidentId
        mriNumber
        narrative
        nicNumber
      }
      officerIncidentSpecifics {
        arrivedAtHospitalAt
        clearedAt
        currentOfficerStatus
        dispatchedAt
        enrouteAt
        enrouteToHospitalAt
        fieldCheck
        id
        incidentId
        lastContactedAt
        logCodeId
        officer {
          id
          personalAttribute {
            cell
            firstName
            id
            lastName
            middleName
            phone
            work
          }
          deptAttribute {
            assignment
            badge
            carNumber
            id
            lastContactedAt
            notes
            stateIdNumber
            ori {
              id
              oriName
              abbreviation
              municipalityNumber
            }
            radioNumber
            scales {
              id
              name
              scaleMake {
                id
                name
              }
              scaleModel {
                id
                name
              }
              serialNumber
            }
            secondaryAddress
            skillsList
            status
            team {
              id
              name
            }
          }
        }
        onSceneAt
        primaryOfficer
        secondaryAddress
        statusId
      }
      opiateBlocker
      ori {
        id
        abbreviation
        agencyType
        oriName
        requireDrugType
        poldOptOut
      }
      personIncidentSpecifics {
        id
        sealed
        bac
        juvenile
        yoe
        drugTypes {
          id
          name
        }
        incidentInvolvement {
          id
          name
          oriId
          position
        }
        person {
          aliases {
            id
            target {
              id
              personalAttribute {
                firstName
                middleName
                lastName
              }
              validPersonAlerts {
                id
                notes
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          genericAttachments {
            attachmentType {
              id
              name
            }
            incident {
              id
              ori {
                id
              }
            }
            confidential
            dataFileName
            dataUrl
            dataUrlWrapper
            description
            employee {
              id
              personalAttribute {
                lastName
                firstName
              }
              deptAttribute {
                badge
                ori {
                  id
                  abbreviation
                }
              }
            }
            id
            lastUpdated
            ownerName
          }
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
            officerId
            person {
              id
            }
          }
          personalAttribute {
            dob
            firstName
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
            }
            id
            lastName
            middleName
            organization
            phone
            cell
            suffix
            driversLicense
            fishWildlifeLicense
            gender {
              id
              name
            }
            licenseState {
              id
              name
              oriId
              position
            }
          }
        }
      }
      vehicleIncidentSpecifics {
        id
        vehicle {
          id
          year
          vehicleColor {
            id
            name
          }
          vehicleMake {
            id
            nhtsaId
            name
          }
          vehicleModel {
            id
            nhtsaId
            name
          }
          vehicleState {
            id
            name
          }
          vehiclePlate {
            id
            name
          }
          vehicleVin {
            id
            name
          }
        }
      }
      queryReturns
      sealed
      locked
      sizeAndWeight {
        id
        endedAt
      }
      stateWideEvents {
        id
        name
        oriId
        position
      }
      rollCall
      team {
        id
        name
        oriId
        position
      }
    }
  }
`;
export const str = `
query GET_INITIAL_CALL_INFO($incidentId: ID!, $originatorId: ID!){
  initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
    __typename
    incidentDetail {
      id
      occurredFrom
      occurredTo
      investigatingOfficer {
        id
        deptAttribute {
          id
          badge
          stateIdNumber
          ori {
            id
            oriName
            abbreviation
          }
        }
        personalAttribute {
          id
          firstName
          lastName
        }
      }
      incidentOffenses {
        id
        locationType {
          id
          name
        }
        offenseViolationPrototype {
          id
          yoe
          offenseCategory {
            id
            name
          }
        }
        suspectVictimAffiliations {
          id
          sealed
          suspect {
            id
            personalAttribute {
              id
              dob
            }
          }
        }
      }
    }
   	incidentArrests {
      id
      sealed
      arrestee {
        id
        personalAttribute {
          id
          lastName
          firstName
          dob
        }
      }
      arrestCharges {
        id
        sealed
        offenseViolationPrototype {
          id
          yoe
        }
      }
    }
    incidentProperties {
      id
      __typename
      colorType {
        id
      }
      description
      disposed
      ibrPropertyDescription {
        id
      }
      ibrSuspectedDrugType {
        id
      }
      incidentOffenses {
        id
        offenseViolationPrototype {
          id
          yoe
        }
        suspectVictimAffiliations {
          id
          sealed
          suspect {
            id
            personalAttribute {
              id
              dob
            }
          }
        }
      }
      labAnalysisInstances {
        id
      }
      location {
        id
      }
      make
      nibrsRelated
      owner {
        id
      }
      ownerNotified
      propertyCode {
        id
      }
      quantity
      serialNumber
      tagNumber
      taggedAt
      taggedBy {
        id
      }
      tempEvidence
      tempEvidenceLocationType {
        id
      }
      unitMeasureType {
        id
      }
      value
      vehicle {
        id
      }
    }
    incidentTickets {
      id
      issuedTo {
        id
        personalAttribute {
          organization
        }
      }
      currentStatus
      ticketNumber
      ticketViolationPrototype {
        id
        fullName
        name
        doNotSubmit
        ticketCategory {
          id
          name
        }
        ticketEntry {
          name
        }
        waiver
      }
    }
    incidentReview {
      id
      reviewStatus {
        id
        name
      }
      statusDate
      approvalStatus {
        id
        name
      }
      investigatingOfficer {
        id
      }
      reviewDate
    }
    address {
      __typename
      id
      name
      validAddressAlerts {
        __typename
        alertType {
          __typename
          id
          name
          alertLevel
          oriId
          position
        }
        expireAt
        id
        notes
        createdAt
        officer {
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
      streetNumber
      streetName
      unit
      city
      state
      zip
      lat
      lng
    }
    area {
      id
      name
      oriId
      position
    }
    callCancelled
    callTime
    cargoTheft
    classification {
      id
      name
      oriId
      position
    }
    commonCallType {
      id
      name
      oriId
      position
    }
    domv
    drugTypes {
      id
      name
      oriId
      position
    }
    drugRelated
    employee {
      id
      personalAttribute {
        aliasName
        bilingual
        buildType {
          id
          name
          oriId
          position
        }
        cell
        deceased
        distinguishingCharacteristics
        dob
        driversLicense
        email
        employer
        employerAddress {
          id
          city
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
        }
        eyeColor {
          id
          name
          oriId
          position
        }
        facialHairType {
          id
          name
          oriId
          position
        }
        fbiNumber
        firstName
        fishWildlifeLicense
        gender {
          id
          name
          oriId
          position
        }
        hairColor {
          id
          name
          oriId
          position
        }
        hairLength {
          id
          name
          oriId
          position
        }
        height
        homeAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
        ibrArresteeRaceType {
          id
          name
          oriId
          position
        }
        id
        juvenile
        lastName
        licenseState {
          id
          name
          oriId
          position
        }
        mailingAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
        }
        mentalHealthAlert
        middleName
        nibrsGender {
          id
          name
          oriId
          position
        }
        notes
        organization
        phone
        pobAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
        }
        race {
          id
          name
          oriId
          position
        }
        residentType {
          id
          name
          oriId
          position
        }
        sid
        substanceAbuseAlert
        suffix
        violenceAlert
        waiverFine
        weaponsAlert
        weight
        work
      }
      deptAttribute {
        assignment
        badge
        carNumber
        id
        lastContactedAt
        notes
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
        }
        radioNumber
        secondaryAddress
        skillsList
        status
      }
    }
    inactive
    id
    incidentNumber
    incidentOrigin {
      id
      name
      oriId
      position
    }
    callPriority {
      id
      name
      oriId
      position
    }
    incidentPriority {
      id
      name
      oriId
      position
    }
    linkedIncidents {
      id
      incidentNumber
    }
    mentalHealthRelated
    narratives
    nicEntries {
      id
      cancelled
      incidentId
      mriNumber
      narrative
      nicNumber
    }
    officerIncidentSpecifics {
      arrivedAtHospitalAt
      clearedAt
      currentOfficerStatus
      dispatchedAt
      enrouteAt
      enrouteToHospitalAt
      fieldCheck
      id
      incidentId
      lastContactedAt
      logCodeId
      officer {
        id
        personalAttribute {
          aliasName
          bilingual
          buildType {
            id
            name
            oriId
            position
          }
          cell
          deceased
          distinguishingCharacteristics
          dob
          driversLicense
          email
          employer
          employerAddress {
            id
            city
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          eyeColor {
            id
            name
            oriId
            position
          }
          facialHairType {
            id
            name
            oriId
            position
          }
          fbiNumber
          firstName
          fishWildlifeLicense
          gender {
            id
            name
            oriId
            position
          }
          hairColor {
            id
            name
            oriId
            position
          }
          hairLength {
            id
            name
            oriId
            position
          }
          height
          homeAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
          ibrArresteeRaceType {
            id
            name
            oriId
            position
          }
          id
          juvenile
          lastName
          licenseState {
            id
            name
            oriId
            position
          }
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          mentalHealthAlert
          middleName
          nibrsGender {
            id
            name
            oriId
            position
          }
          notes
          organization
          phone
          pobAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          race {
            id
            name
            oriId
            position
          }
          residentType {
            id
            name
            oriId
            position
          }
          sid
          substanceAbuseAlert
          suffix
          violenceAlert
          waiverFine
          weaponsAlert
          weight
          work
        }
        deptAttribute {
          assignment
          badge
          carNumber
          id
          lastContactedAt
          notes
          stateIdNumber
          ori {
            id
            oriName
            abbreviation
            municipalityNumber
          }
          radioNumber
          secondaryAddress
          skillsList
          status
        }
      }
      onSceneAt
      primaryOfficer
      secondaryAddress
      statusId
    }
    opiateBlocker
    ori {
      id
      abbreviation
      agencyType
      oriName
    }
    personIncidentSpecifics {
      id
      sealed
      bac
      juvenile
      yoe
      incidentInvolvement {
        id
        name
        oriId
        position
      }
      person {
        aliases {
          id
          target {
            id
            validPersonAlerts {
              alertType {
                name
                alertLevel
              }
            }
          }
        }
        id
        aliases {
          id
          description
          createdAt
          updatedAt
          target {
            aliases {
              id
              target {
                id
                validPersonAlerts {
                  alertType {
                    name
                    alertLevel
                  }
                }
              }
            }
            validPersonAlerts {
              alertType {
                name
                alertLevel
              }
            }
            id
            personalAttribute {
              dob
              firstName
              homeAddress {
                id
                city
                lat
                lng
                name
                state
                streetName
                streetNumber
                unit
                zip
                validAddressAlerts {
                  alertType {
                    id
                    name
                    alertLevel
                    oriId
                    position
                  }
                  expireAt
                  id
                  notes
                  officer {
                    id
                  }
                }
              }
              mailingAddress {
                id
                city
                lat
                lng
                name
                state
                streetName
                streetNumber
                unit
                zip
              }
              id
              lastName
              middleName
              organization
              phone
              cell
              suffix
              driversLicense
              fishWildlifeLicense
              licenseState {
                id
                name
                oriId
                position
              }
            }
          }
        }
        validPersonAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
          person {
            id
          }
        }
        personalAttribute {
          dob
          firstName
          homeAddress {
            id
            city
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                id
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
          mailingAddress {
            id
            city
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            zip
          }
          id
          lastName
          middleName
          organization
          phone
          cell
          suffix
          driversLicense
          fishWildlifeLicense
          licenseState {
            id
            name
            oriId
            position
          }
        }
      }
    }
    vehicleIncidentSpecifics {
      id
      vehicle {
        id
        vehicleMake {
          id
          nhtsaId
          name
        }
        vehicleModel {
          id
          nhtsaId
          name
        }
        vehicleState {
          id
          name
        }
        vehiclePlate {
          id
          name
        }
        vehicleVin {
          id
          name
        }
      }
    }
    queryReturns
    sealed
    locked
    stateWideEvents {
      id
      name
      oriId
      position
    }
    rollCall
    team {
      id
      name
      oriId
      position
    }
  }    
}
`;
